import * as defaultImport from "@splunk/visualizations/Map";
export * from "@splunk/visualizations/Map";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
